var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",style:('background-color: '+_vm.data.footerBackgroundColour)},[_c('p',{staticClass:"centered"},[_vm._l((_vm.data.footerLogo.images),function(image){return _c('img',{attrs:{"src":image.url}})}),_vm._v(" "),_c('br'),_c('br'),_vm._v("\n    "+_vm._s(_vm.data.footerText)+"\n  ")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3696e00e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterBlock.vue
// module id = null
// module chunks = 